import { liveCasinoCheck } from "../../js/api/liveCasino.js";

let LiveCasino = {
    render: async () => {
        let view =  /*html*/`
            <iframe style="width:125%;min-height: 98vh;" src="data:text/html,<h1></h1>" id="gameIframe" frameborder="0" noresize="noresize" allow="geolocation 'self'; autoplay 'self'"></iframe>
        `
        return view;
    },
    after_render: async () => {
        document.querySelector('meta[name="viewport"]').setAttribute("content", 'width=initial');

        let slotId = localStorage.getItem('slotId');

        if (!slotId || slotId == 0 || slotId == 'null') {
            const response = await liveCasinoCheck();
            if (response.success && response.slot_id) {
                slotId = response.slot_id;
                localStorage.setItem('slotId', slotId);
            }
        }

        if (!(!slotId || slotId == 0 || slotId == 'null')) {
            $('#gameIframe').attr('src', `https://evoframe.cyobc.com/Default.aspx?companyToken=jo3sRZTUck6EDb9a&usID=${slotId}`);
        }


    },
    on_unload: async (socket) => {
        document.querySelector('meta[name="viewport"]').setAttribute("content", 'width=device-width, initial-scale=1');
    },
}

export default LiveCasino;
